import { apiClient } from '@/shared/api';
import type {
  CorrectionAttendanceSummary,
  CorrectionRequest,
  CorrectionRequestWithAttendance,
  PaginatedResponse,
} from '@aegislab/shared';

export type { CorrectionAttendanceSummary, CorrectionRequest, CorrectionRequestWithAttendance };

export interface ReviewedCorrectionsParams {
  from: string;
  to: string;
  status?: 'APPROVED' | 'REJECTED';
  cursor?: string;
  limit?: number;
}

// X3 단계 1a (D8): admin scope correction read 흡수. 호출자 갱신은 단계 1d.
export const fetchPendingCorrections = async (): Promise<
  PaginatedResponse<CorrectionRequestWithAttendance>
> => {
  const response = await apiClient.get<PaginatedResponse<CorrectionRequestWithAttendance>>(
    '/attendance/correction/pending'
  );
  return response.data;
};

export const fetchReviewedCorrections = async (
  params: ReviewedCorrectionsParams
): Promise<PaginatedResponse<CorrectionRequestWithAttendance>> => {
  const response = await apiClient.get<PaginatedResponse<CorrectionRequestWithAttendance>>(
    '/attendance/correction/reviewed',
    { params }
  );
  return response.data;
};

export const correctionApi = {
  fetchPendingCorrections,
  fetchReviewedCorrections,
};
